export const MENU_CATEGORY_DATA_ATTRIBUTE = 'data-menu-category';
export const NO_MENU_DATA_ATTRIBUTE = 'data-no-menu';
export const SAMPLE_SECTION_E2E_IGNORE = 'sample-section-e2e-ignore';
export const SPECTRUM_COMPONENT_SAMPLES_ID = 'spectrum-component-samples';
export const SPECTRUM_COMPARISON_SAMPLES_ID = 'spectrum-comparison-samples';
